/** @jsx jsx */
import React from "react"
import { jsx, Box, Flex } from "theme-ui"
import { GatsbyImage } from "gatsby-plugin-image"
import ContentfulRichText from "../../shared/ContentfulRichText"
import useTrackWindowSize from "../../../hooks/useTrackWindowSize"
import WistiaEmbed from "../../shared/WistiaEmbed"
import useBorderStyles from "../../../hooks/useBorderStyle"

const SideBySideBlock = ({ block, isDark = false }) => {
  const {
    content,
    desktopImage,
    mobileImage,
    imageBackgroundColor,
    imagePosition,
    classname,
    textContainerWidth,
    wistiaItem,
  } = block
  const borderStyle = useBorderStyles(classname)

  const { mobile } = useTrackWindowSize()
  return (
    <Flex
      sx={{
        flexDirection: ["column", "column", "column", imagePosition === "left" ? "row-reverse" : "row"],
        padding: ["10px 20px", null, null, null, "18px 0"],
        alignItems: "center",
        gap: ["32px", "48px"],
      }}
      className={classname}
    >
      <Box
        sx={{
          maxWidth: [
            "100%",
            "100%",
            "100%",
            "50%",
            textContainerWidth ? `calc(${textContainerWidth} - 24px)` : "490px",
          ],
        }}
        className="side-by-side-content"
      >
        <ContentfulRichText richText={content} isDark={isDark} />
      </Box>
      <Box
        sx={{
          alignItems: "center",
          verticalAlign: "center !important",
          width: "100%",
          maxWidth: [
            "100%",
            "100%",
            "100%",
            "50%",
            textContainerWidth ? `calc(100% - ${textContainerWidth} - 24px)` : "620px",
          ],
        }}
        className="side-by-side-image-parent"
      >
        <Box
          sx={{
            variant: "borders.card",
            boxShadow: imageBackgroundColor
              ? `${imagePosition === "left" ? "20px" : "-20px"} 20px ${imageBackgroundColor}`
              : "none",
            display: desktopImage || mobileImage ? "flex" : "block",
            alignItems: "center",
          }}
          className="side-by-side-image"
        >
          {/* <GatsbyImage
            image={mobile && mobileImage ? mobileImage.gatsbyImageData : desktopImage.gatsbyImageData}
            alt={desktopImage.description}
            className="side-by-side-image"
            sx={{
              width: "100%",
              borderRadius: "8px",
            }}
            objectFit="contain"
          /> */}
          {(desktopImage || mobileImage) && !wistiaItem && (
            <GatsbyImage
              image={mobile && mobileImage ? mobileImage.gatsbyImageData : desktopImage.gatsbyImageData}
              alt={desktopImage.description}
              className="side-by-side-image"
              sx={{
                width: "100%",
                borderRadius: "8px",
              }}
              objectFit="contain"
            />
          )}
          {wistiaItem && !(desktopImage || mobileImage) && (
            <Box>
              {wistiaItem.wistiaHeading && <h3>{wistiaItem.wistiaHeading}</h3>}
              <Box className="wistia-all-wrapper">
                {wistiaItem.videos?.items?.map((item, index) => (
                  <Box
                    key={index}
                    sx={{
                      width: "100%",
                      mb: 4,
                      ...(borderStyle || {}),
                    }}
                  >
                    <WistiaEmbed hashedId={item.hashed_id} />
                  </Box>
                ))}
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Flex>
  )
}

export default SideBySideBlock
